import { createUseStyles } from 'react-jss';

const styles = {
  formInputItem: {
    width: '50%',
    '@media screen and (max-width: 1580px)': {
      width: '60%'
    }
  },
  searchButton: {
    margin: 'auto 1em'
  },
  dialog: {
    width: '40%'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'QTProjectImportDialog'
});
